import { Pipe, PipeTransform } from '@angular/core';
import { MENU_ITEM_LIST } from '../../core/config/Constants';

@Pipe({
  name: 'customTitle'
})
export class CustomTitlePipe implements PipeTransform {

  transform(value: string): string {
    let str = '';
    if (value != null && value.length > 0) {
      if (value == 'About') {
        str = 'About';
      } else if (value == 'Content') {
        str = 'Content';
      } else if (value == 'Sessions') {
        str = 'Sessions';
      } else if (value == 'Speakers') {
        str = 'Speakers';
      } else if (value == 'VenueDetails') {
        str = 'Venue Details';
      } else if (value == 'Polls') {
        str = 'Polls';
      } else if (value == 'QnA') {
        str = 'Q&A';
      } else if (value == 'Sponsors') {
        str = 'Sponsors';
      } else if (value == 'Feedback') {
        str = 'Feedback';
      } else if (value == 'Contact Us') {
        str = 'ContactUs';
      } else if (value == 'Exhibitors') {
        str = 'Exhibitors';
      } else if (value == 'Organizers') {
        str = 'Organizers';
      } else if (value == 'registration') {
        str = 'Registration';
      } else if (value == 'notifications') {
        str = 'Notifications';
      } else if (value == 'chatroom') {
        str = 'Chatroom';
      } else if (value == 'aboutCity') {
        str = 'About City';
      } else if (value == 'attendees') {
        str = 'Attendees';
      } else if (value == 'activities') {
        str = 'Activities';
      } else if (value == 'mySessions') {
        str = 'My Schedule';
      } else if (value == 'quiz') {
        str = 'Quiz';
      } else if (value == 'leaderboard') {
        str = 'Leaderboard';
      } else if (value == 'notes') {
        str = 'Notes';
      }else if (value.toLowerCase() == 'streaming') {
        str = 'Live Streaming';
      }
    }
    return str;
  }
}


// WEBPACK FOOTER //
// /app/src/app/core/pipes/custom-title.pipe.ts